<template>
  <div id="app">
    <the-header />
    <the-content>
      <h1 class="main-headline">Umbruch</h1>
      <p>Lorem ipsum dolor sit amet</p>
      <indentation-overview />
      <indentation-preview />
    </the-content>
  </div>
</template>

<script>
import TheHeader from './components/site/TheHeader.vue'
import TheContent from './components/site/TheContent.vue'
import IndentationOverview from './components/indentation/IndentationOverview.vue'
import IndentationPreview from './components/indentation/IndentationPreview.vue'

export default {
  name: 'app',
  components: {
    TheHeader,
    TheContent,
    IndentationOverview,
    IndentationPreview
  },
  computed: {
    language () {
      return this.$store.state.language
    }
  }
}
</script>

<style lang="scss">
:root {
  --color-main: #b00000;
  --color-text: #363636;
  --color-bg: #f8f2e3;

  --site-padding: 4vmin;

  --shadow-1: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  --shadow-2: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

*,
*::before,
*::after {
  box-sizing: border-box;
  font-family: inherit;
  font-size: inherit;
}

html {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  font-size: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  background-color: var(--color-bg);
  color: var(--color-text);
  margin: 0;
}

img {
  max-width: 100%;
}

.main-headline {
  font-size: 1.75rem;
}

.sub-headline {
  font-size: 1.33rem;
}

.small-headline {
  font-size: 1rem;
}

button {
  border: 0;
  border-radius: 0.25rem;
  background-color: var(--color-text);
  color: var(--color-bg);
  font-weight: bold;
  letter-spacing: 0.03em;
  padding: 0.25em 0.5em;

  &:focus {
    outline: 2px dotted var(--color-text);
  }
}
</style>
